export const faqs = [
  {
    question: "En combien de temps intervenez-vous pour un volet bloqué ?",
    answer: "Nous intervenons généralement dans les 24 heures suivant votre appel, et souvent le jour même pour les urgences à Strasbourg et dans le Bas-Rhin. Si vous nous appelez le matin, il est fréquent que nous trouvions un créneau l’après-midi ou le soir. Pour les dépannages en soirée ou le week-end, un service d’urgence est disponible : appelez le 03 74 47 32 40 et nous vous indiquons le prochain horaire disponible.",
  },
  {
    question: "Le déplacement est-il payant ?",
    answer: "Non, le déplacement et le diagnostic sont gratuits et sans engagement. Vous ne payez que la réparation si vous acceptez le devis. Nous croyons en la transparence : avant toute intervention, le technicien vous explique le problème, la solution et le coût. Aucune surprise, aucun frais caché.",
  },
  {
    question: "Réparez-vous le jour même ?",
    answer: "Dans la grande majorité des cas, oui. Les pannes courantes — sangle cassée, cordon usé, télécommande déprogrammée, fin de course déréglée, lames déformées — peuvent être réparées sur place en une seule visite. Si une pièce spécifique doit être commandée, nous revenons dans les 24 à 48 heures maximum. Nous ne vous laissons jamais avec un volet bloqué plus longtemps que nécessaire.",
  },
  {
    question: "Quelles pannes sont considérées comme urgentes ?",
    answer: "Tout volet bloqué en position ouverte ou fermée est considéré comme prioritaire. Un volet ouvert expose votre maison aux intempéries et à l’intrusion. Un volet fermé bloque l’aération, la lumière et peut rendre une issue de secours inaccessible. Les bruits anormaux répétés, les signes de surchauffe du moteur ou une télécommande totalement sans réaction sont également des signes qu’il faut agir rapidement pour éviter d’endommager d’autres composants.",
  },
];

export default function FAQ() {
  return (
    <section className="bg-white py-14 md:py-20">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <h2 className="text-brand-blue text-2xl md:text-3xl font-extrabold text-center mb-10 md:mb-14">
          Questions fréquentes sur le dépannage urgent
        </h2>
        <div className="space-y-6">
          {faqs.map((faq, i) => (
            <div key={i} className="bg-brand-light rounded-xl border border-brand-border p-6 md:p-8">
              <h3 className="text-brand-blue text-base font-bold mb-3">{faq.question}</h3>
              <p className="text-brand-text text-sm leading-relaxed">{faq.answer}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}